<template>
    <mw-dialog  size="" title="转换办理人" :footerButton="footerButton" ref="dialog">
      <div style="padding: 10px;">
        <el-form :model="editingForm" label-width="150px" :rules="editingRule" ref="editingFormRef">
          <el-form-item label="在办节点" prop="oneNode">
            <el-select  v-model="editingForm.oneNode" style="width:100%">
              <el-option
                v-for="item in unfinishedTaskQueue"
                :key="item.id"
                :label="`${item.name||''}-${item.department||''}-${item.candidateName||''}`.replace(/-$|^-|--/g, '')"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="办理人" prop="twoMan">
            <all-man-select v-model="editingForm.twoMan"/>
          </el-form-item>

        </el-form>
      </div>
    </mw-dialog>
</template>

<script>
import api from "@/common/api/maintain";
import AllManSelect from "../common/allManSelect";
export default {
  data() {
    return {
      editingForm: {
        oneNode: "", // taskId
        twoMan: []
      },
      unfinishedTaskQueue: [],
      taskTransactorList: [],
      nextFlowList: [],
      editingRule: {
        oneNode: [{ required: true, message: "请选择在办节点" }],

        twoMan: [
          {
            validator: (rule, value, callback) => {
              if (!value || !value.length) {
                callback("请选择办理人");
              } else {
                callback();
              }
            }
          }
        ]
      },
      footerButton: [
        {
          label: "取消",
          func: () => {
            this.mwRef("dialog").hide();
          }
        },
        {
          label: "确定",
          func: async () => {
            if (await this.mwRef("editingFormRef").validate()) {
              if (
                (await api.replaceTaskIdentity(this.editingForm.oneNode, {
                  //departmentId: this.editingForm.twoMan[0].departmentId,
                  id: this.editingForm.twoMan[0].id,
                  name: this.editingForm.twoMan[0].name,
                  type: 'U'
                }, {})).success
              ) {
                this.mwMsg("转换成功");
                //刷新列表
                this.$emit('updateTable');
                this.mwRef("dialog").hide();
              }
            }
          }
        }
      ],

      applicationId: "",
      businessId: "",
      batchId:'',
      moduleId: ""
    };
  },
  computed: {
    twoManUrl() {

    },
    twoManMultiple() {
      return false;
    }
  },
  watch: {
    async "editingForm.oneNode"(nv, ov) {
      if (nv !== ov) {
        this.editingForm = {
          ...this.editingForm,
          twoMan: []
        };
      }
    },
  },
  methods: {
    async action({ applicationId, businessId, batchId, moduleId }) {
      this.applicationId = applicationId;
      this.businessId = businessId;
      this.batchId = batchId;
      this.moduleId = moduleId;
      this.editingForm = {
        oneNode: "",
        twoMan: []
      };
      this.mwRef("dialog").show();

      this.getUnfinishedTaskQueue();
    },

    async getUnfinishedTaskQueue() {
      this.unfinishedTaskQueue = [];
      this.unfinishedTaskQueue =
        (await api.listUnfinishedTask(this.batchId, { type: 1, unfinished:true, undrafted:true })).result ||
        [];
      // must update it manully
      if (!this.editingForm.oneNode && this.unfinishedTaskQueue[0]) {
        this.editingForm = {
          ...this.editingForm,
          oneNode: this.unfinishedTaskQueue[0].id
        };
      }
    }
  },

  components: {
    AllManSelect
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/set/flowInterfering/actions/replaceTaskIdentity.vue